import { money } from "@/lib/money";

const DAY = 86400000;
const LAB = { week: "this week", month: "this month", year: "this year" };

export function goalCalc(prefs, savings, s, e, mode) {
  const g = +prefs.goal || 0;
  if (!(g > 0) || !prefs.goalDate) return null;
  const saved = savings.reduce((t, i) => t + (+i.amt || 0), 0);
  const rem = Math.max(0, g - saved);
  const pct = Math.min(100, (Math.max(0, saved) / g) * 100);
  if (!rem) return { text: "Goal reached! Well done.", pct };
  const td = new Date(); td.setHours(0, 0, 0, 0);
  const target = new Date(prefs.goalDate + "T00:00:00");
  if (target < td) return { text: `Goal date passed · ${money(rem)} still to save`, pct };
  const left = Math.round((target - td) / DAY) + 1;
  const ps = Math.max(s, td), pe = Math.min(e, target.getTime() + DAY);
  const pd = Math.max(0, Math.round((pe - ps) / DAY));
  if (!pd) return { text: `${money(rem)} to save by ${prefs.goalDate}`, pct };
  const need = Math.min(rem, (rem / left) * pd);
  return { text: `Save ${money(Math.ceil(need * 100) / 100)} more ${LAB[mode]} · ${money(rem)} to go`, pct };
}
